<template>
  <div class="store-map">

    <div class="switch-map" v-if="isDevice !== 'desktop'">
      <div class="switch-map__buttons">
        <div class="switch-map__button">
          <button
              class="map-point__button"
              :class="{'is-active': switchListMap === 'list'}"
              @click="switchListMap = 'list'"
          >
            Списком
          </button>
        </div>
        <div class="switch-map__button">
          <button
              class="map-point__button"
              :class="{'is-active': switchListMap === 'map'}"
              @click="switchListMap = 'map'"
          >
            На карте
          </button>
        </div>
      </div>
    </div>

    <div class="assurance-body">
      <div class="map-navigation">
        <div class="map-navigation__selection">

          <div class="selection-item">
            <input
                name="city"
                class="uk-input map-selector"
                placeholder="Выберите город"
                autocomplete="disabled"
                @keyup="insertedSearchFilter"
                @focus="showListCities = true"
                @blur="$event.target.nextSibling.matches(':hover') ? '' : showListCities = false"
                v-model="selectedCityName"
            />
            <div class="selection-item__list" :class="{'is-active' : showListCities}">
              <div v-for="(city, index) in initDataCities"
                   :key="index"
                   v-show="showBySearch(city)"
                   @click="onChangeCity(city)"
                   class="selection-item__list-item"
              >
                {{ city.name }}
              </div>
            </div>
          </div>
          <div class="selection-item__location" @click="getLocationByClientIP">
            <div class="eik-i eik-i-location" v-if="!loadLocation"></div>
            <div class="location__spin" uk-spinner v-else></div>
          </div>
        </div>

        <div class="map-list" v-if="isDevice === 'desktop' || switchListMap === 'list'">
          <div
              class="map-point"
              v-for="(point, index) in initDataPoints"
              :key="index"
          >
            <p class="map-point__type">{{ point.segment ? point.segment : 'Сеть магазинов' }}</p>
            <p class="map-point__title">{{ fixNamePoint(point) }}</p>

            <button
                class="map-point__button"
                :class="{'is-active': selectedPoint === point.id}"
                @click="selectPointOnMap(point)"
            >
              На карте
            </button>

            <div v-if="point.working_time" class="map-point__row" style="display: block">
              Часы работы:
              <div class="working-time">
                <div class="working-time__status">
                  {{ workingTimeStatus(point.working_time_array, point.utc) }}
                </div>
                <div
                    class="working-time__message"
                    :class="{ 'is_active': showListWorkingTime === index }"
                    @click.stop="toggleWorkingTimeList(index)"
                    v-clickoutside="clickOutside"
                >
                  <span>{{ workingTimeMessage(point.working_time_array, point.utc) }}</span>
                  <div class="working-time__list" :class="{'is-active' : showListWorkingTime === index}">
                    <div
                      v-for="(item, ii) in point.working_time_array"
                      :key="ii"
                      class="list__item"
                      :class="{list_active : dayCurrent == item.day }"
                    >
                      <span>{{ item.day }}</span> {{ item.start ? item.start : 'выходной' }}  {{ item.end ? '- ' + item.end : '' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="map-point__row">
              Телефон:
              <span v-if="point.phone && point.phone.length">
                <template v-for="(item, index) in point.phone">
                  <div :key="index">{{ item }}</div>
                </template>
              </span>
              <span v-else class="nf-point">не указан</span>
            </div>
            <div class="map-point__row">
              E-mail:
              <span v-if="point.email && point.email.length">
                <template v-for="(item, index) in point.email">
                  <div :key="index">{{ item }}</div>
                </template>
              </span>
              <span v-else class="nf-point">не указан</span>
            </div>
            <div class="map-point__row">
              Cайт:
              <span v-if="point.url && point.url.length">
              <template v-for="(item, index) in point.url">
                <a :href="item" target="_blank" :key="index">{{ item }}</a>
              </template>
            </span>
              <span v-else class="nf-point">не указан</span>
            </div>
            <p class="map-point__address" v-html="fixTransferText(point.address)"></p>
          </div>
        </div>
        <div class="map-message">
          <span @click="$emit('feedback')">Сообщите об ошибке</span>
        </div>
      </div>

      <div
          class="interactive-map"
          v-show="isDevice === 'desktop' || switchListMap === 'map'"
      >
        <yandex-map
            :settings="settings"
            :coords="initCoords"
            :controls="controls"
            :zoom="mapZoom"
            ref="ymap"
            @map-was-initialized="onMapInitialized"
        >
          <ymap-marker
              v-for="(point, index) in mapPoints"
              :key="point.id || index"
              :marker-id="point.id || index"
              :coords="point.coords"
              :hint-content="point.signboard"
              :icon="selectedPoint === point.id ? selectedMarkerIcon : markerIcon"
              :balloon-template="point.balloon"
          ></ymap-marker>
        </yandex-map>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import utils from '../utils';

export default {
  components: {
    yandexMap,
    ymapMarker
  },
  props: {
    isDevice: null,
  },
  data() {
    return {
      apiCities: 'get/cities/eikosha',
      apiPoints: 'get/points/eikosha',
      initDataCities: [],
      initDataPoints: [],
      initCoords: [55.4507, 37.3656],
      mapZoom: 12,
      pendingCityMapView: null,
      yandexMapInstance: null,
      selectedCity: null,
      selectedSearch: [],
      selectedCityName: '',
      showListCities: false,
      selectedPoint: null,
      settings: {
        apiKey: process.env.VUE_APP_YANDEX_API_KEY,
        lang: 'ru_RU',
        coordorder: 'latlong',
        enterprise: false,
        version: '2.1',
      },
      markerIcon: {
        layout: 'default#image',
        imageHref: '/img/markerDefault.png',
        imageSize: [62, 56],
        imageOffset: [-31, -56],
      },
      selectedMarkerIcon: {
        layout: 'default#image',
        imageHref: '/img/markerSelected.png',
        imageSize: [62, 56],
        imageOffset: [-31, -56],
      },
      controls: ['zoomControl', 'typeSelector', 'fullscreenControl'],
      loadLocation: false,
      switchListMap: 'list',
      showListWorkingTime: null,
    }
  },
  computed: {
    dayCurrent() {
      const days = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
      const date = new Date();
      return days[date.getDay()];
    },
    timeCurrent() {
      return this.$moment(new Date()).format('H:mm')
    },
    mapPoints() {
      return (this.initDataPoints || []).filter((point) => this.normalizeCoords(point && point.coords))
    },
    detectRobot() {
      // eslint-disable-next-line
      const robots = new RegExp([
        /bot/,/spider/,/crawl/,
        /APIs-Google/,/AdsBot/,/Googlebot/,/Googlebot-Mobile/,
        /mediapartners/,/Google Favicon/,/Googlebot-Image/,
        /FeedFetcher/,/Google-Read-Aloud/,
        /DuplexWeb-Google/,/googleweblight/,
        /bing/,/yandex/,/baidu/,/duckduck/,/yahoo/,
        /ecosia/,/ia_archiver/,
        /facebook/,/instagram/,/pinterest/,/reddit/,
        /slack/,/twitter/,/whatsapp/,/youtube/,
        /semrush/,
      ].map((r) => r.source).join("|"),"i");

      return robots.test(navigator.userAgent);
    }
  },
  methods: {
    timeToDate: function(time) {
      if (!time || typeof time !== 'string') return null
      const chunks = time.split(':')
      if (chunks.length < 2) return null
      const date = new Date()
      const hours = Number(chunks[0])
      const minutes = Number(chunks[1])
      if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null

      date.setHours(hours)
      date.setMinutes(minutes)

      return date;
    },
    workingTimeStatus: function(dateArray, utc) {
      if (!Array.isArray(dateArray) || !dateArray.length) return 'Закрыто'
      const dateCurrent = dateArray.find(date => {return this.dayCurrent == date.day})
      const now = new Date()

      let curOffset = new Date().getTimezoneOffset() / 60 * -1
      now.setHours(now.getHours() - ((+curOffset) - (+utc || 0)))

      if (dateCurrent && dateCurrent['start'] && dateCurrent['end']) {
        let dateStart = this.timeToDate(dateCurrent['start'], curOffset, utc)
        let dateEnd = this.timeToDate(dateCurrent['end'], curOffset, utc)

        if (dateStart && dateEnd && now >= dateStart && now <= dateEnd) return 'Открыто'
      }
      return 'Закрыто'
    },
    workingTimeMessage: function(dateArray, utc) {
      if (!Array.isArray(dateArray) || !dateArray.length) return 'Не работает'
      const dateCurrent = dateArray.find(date => {return this.dayCurrent == date.day})
      const now = new Date()
      let curOffset = new Date().getTimezoneOffset() / 60 * -1
      now.setHours(now.getHours() - ((+curOffset) - (+utc || 0)))

      if (dateCurrent) {
        const dateStart = dateCurrent['start'] ? this.timeToDate(dateCurrent['start']) : null
        if (dateStart && now < dateStart) return 'Откроется в ' + dateCurrent['start']

        const dateEnd = dateCurrent['end'] ? this.timeToDate(dateCurrent['end']) : null
        if (!dateEnd || now > dateEnd) {
          let dateOpen = null
          let index = dateArray.indexOf(dateCurrent)
          let count = 0
          const max = dateArray.length

          while (dateOpen === null && count < max) {
            index = index + 1 === max ? 0 : index + 1
            dateOpen = dateArray[index] && dateArray[index]['start']
              ? dateArray[index]['start']
              : null
            count++
          }
          return dateOpen ? 'Откроется в ' + dateOpen : 'Не работает'
        }

        return 'Закроется в ' + dateCurrent['end']
      }

      return 'Не работает'
    },
    toggleWorkingTimeList(index) {
      this.showListWorkingTime = this.showListWorkingTime === index ? null : index;
    },
    clickOutside() {
      this.showListWorkingTime = null;
    },
    setBlockTime: function () {
      let blockTime = new Date()
      blockTime.setDate(blockTime.getDate() + 4)
      localStorage.setItem('blockTime', +blockTime)
    },
    getInitDataCities: async function () {
      const {fetchData} = utils()
      let response = await fetchData(this.apiCities)
      this.initDataCities = response ? response : []

      const blockTime = localStorage.getItem('blockTime')

      if (blockTime !== null) {
        if (+new Date() >= parseInt(blockTime)) {
          localStorage.removeItem('blockTime')
          localStorage.removeItem('location')
        } else {

          const location = JSON.parse(localStorage.getItem('location'))
          this.setBlockTime()

          this.selectedCity = this.initDataCities.find(city => {
            return city.name === location.name
          })

          if (!this.selectedCity) return -1

          this.selectedCityName = this.selectedCity.name
          this.getInitDataPoints(this.selectedCity)
          return 1
        }
      }

      this.getLocationByClientIP()
      return 0
    },
    getInitDataPoints: async function (city) {
      const {fetchData} = utils()
      if (!city || !city.id) return -1
      const response = await fetchData(`${this.apiPoints}/${city.id}`)
      if (!response) return -1

      let temp = response
      for (let i = 0; i < response.length; i += 1) {
        const point = temp[i]
        const address = point.address
        if (!point.coords) {
          point.coords = [
            address && address.latitude,
            address && address.longitude,
          ];
          const {icon} = point
          delete point.icon
          point.icon = {content: icon}
        }
        if (address && typeof address === 'object') {
          point.address = address.name
        }
        point.coords = this.normalizeCoords(point.coords)
          || this.normalizeCoords([point.latitude, point.longitude])
      }
      this.initDataPoints = temp
      this.applyCityMapView(temp)
    },
    normalizeCoords(coords) {
      if (!Array.isArray(coords) || coords.length < 2) return null
      const lat = Number(coords[0])
      const lon = Number(coords[1])
      if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null
      if (lat === 0 && lon === 0) return null
      if (Math.abs(lat) > 90 || Math.abs(lon) > 180) return null
      return [lat, lon]
    },
    percentile(sorted, p) {
      const index = (sorted.length - 1) * p
      const lower = Math.floor(index)
      const upper = Math.ceil(index)
      if (lower === upper) return sorted[lower]
      return sorted[lower] + (sorted[upper] - sorted[lower]) * (index - lower)
    },
    median(values) {
      const sorted = [...values].sort((a, b) => a - b)
      const mid = Math.floor(sorted.length / 2)
      return sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2
    },
    computeCityMapView(cityPoints, defaultZoom = 12, padding = 0.7) {
      const coords = (cityPoints || [])
        .map((point) => this.normalizeCoords(point && point.coords))
        .filter(Boolean)
      if (!coords.length) return null

      const lats = coords.map((item) => item[0])
      const lons = coords.map((item) => item[1])
      const sortedLats = [...lats].sort((a, b) => a - b)
      const sortedLons = [...lons].sort((a, b) => a - b)

      const centerLat = this.median(lats)
      const centerLon = this.median(lons)
      const minLat = this.percentile(sortedLats, 0.05)
      const maxLat = this.percentile(sortedLats, 0.95)
      const minLon = this.percentile(sortedLons, 0.05)
      const maxLon = this.percentile(sortedLons, 0.95)

      let zoom = defaultZoom
      if (coords.length === 1) {
        zoom = 12
      } else {
        const latSpan = Math.max(maxLat - minLat, 0.005)
        const lonSpan = Math.max(maxLon - minLon, 0.003)
        const latZoom = Math.log2(360 / (latSpan * padding))
        const lonZoom = Math.log2(360 / (lonSpan * padding))
        zoom = Math.floor(Math.min(latZoom, lonZoom))
        zoom = Math.min(14, Math.max(11, zoom))
      }

      return {
        coords: [centerLat, centerLon],
        zoom,
      }
    },
    applyMapViewport(map, view) {
      if (!map || !view) return false
      const { coords, zoom } = view
      if (typeof map.setCenter === 'function') {
        map.setCenter(coords, zoom)
        return true
      }
      if (typeof map.setZoom === 'function') {
        map.setZoom(zoom)
      }
      if (typeof map.panTo === 'function') {
        map.panTo(coords, { flying: true })
      }
      return true
    },
    getYandexMap() {
      const map = this.$refs.ymap
      return this.yandexMapInstance || (map && (map.myMap || map.ymap))
    },
    onMapInitialized(map) {
      this.yandexMapInstance = map
      if (this.pendingCityMapView) {
        this.applyMapViewport(map, this.pendingCityMapView)
        this.pendingCityMapView = null
      }
    },
    syncCityMapView(view) {
      if (!view) return
      this.mapZoom = view.zoom
      this.initCoords = view.coords
      this.$nextTick(() => {
        if (this.applyMapViewport(this.getYandexMap(), view)) {
          this.pendingCityMapView = null
          return
        }
        this.pendingCityMapView = view
      })
    },
    applyCityMapView(cityPoints) {
      this.syncCityMapView(this.computeCityMapView(cityPoints, 12, 0.7))
    },
    setMapCenter(coords, zoom) {
      const center = this.normalizeCoords(coords)
      if (!center) return
      const nextZoom = Number.isFinite(zoom) ? zoom : this.mapZoom
      this.mapZoom = nextZoom
      this.initCoords = center
      this.$nextTick(() => {
        const map = this.getYandexMap()
        if (!map) return
        if (typeof map.setCenter === 'function') {
          map.setCenter(center, nextZoom)
        } else if (typeof map.panTo === 'function') {
          map.panTo(center, { checkZoomRange: true })
        }
      })
    },
    selectPointOnMap(point) {
      if (!point) return
      this.selectedPoint = point.id
      this.setMapCenter(point.coords, 15)
    },
    getLocationByClientIP: async function () {
      let IP = null
      if (this.loadLocation) return -1

      this.loadLocation = true
      const targetGetIP = process.env.VUE_APP_CLIENT_IP

      if (this.detectRobot === false) {
        await axios
            .get(targetGetIP)
            .then((res) => IP = res.data);
      }

      if (IP) {
        const targetGetLocal = `${process.env.VUE_APP_GEO_URL}/${process.env.VUE_APP_GEU_KEY}/json/${IP}`
        let response = null
        await axios
            .get(targetGetLocal)
            .then((res) => response = res.data);

        this.loadLocation = false
        if (!response) return -1

        let location = {
          lat: response.city.lat,
          lon: response.city.lon,
          name: response.city.name_ru
        }

        this.selectedCity = this.initDataCities.find(city => {
          return city.name === location.name
        })

        this.getInitDataPoints(this.selectedCity)
        this.selectedCityName = this.selectedCity?.name
        localStorage.setItem('location', JSON.stringify(location))
        this.setBlockTime()
      }
      this.loadLocation = false
    },
    showBySearch(value) {
      if (!this.selectedSearch || this.selectedSearch.length < 2) return true;
      return (value.name && value.name.toLowerCase().includes(this.selectedSearch.toLowerCase()));
    },
    onChangeCity(city) {
      this.showListCities = false
      this.selectedCity = city
      this.selectedCityName = city.name
      this.switchListMap = 'list'
      this.getInitDataPoints(city)
    },
    insertedSearchFilter(event) {
      this.selectedSearch = event.target.value
      this.$forceUpdate();
    },
    fixTransferText(str) {
      if (!str || typeof str !== 'string') return str || ''
      const pos = str.lastIndexOf(',') + 2
      return str.substr(0, pos) + '<nobr>' + str.substr(pos) + '</nobr>';
    },
    fixNamePoint(point) {
      return point.signboard || 'Автомагазин'
    }
  },
  watch: {
    selectedPoint(value) {
      if (value && this.isDevice !== 'desktop') {
        this.switchListMap = 'map'
      }
    }
  },
  mounted() {
    this.getInitDataCities()
  }
}
</script>